/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 新旧版本切换链接
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: dictionary.SwitchEndpointDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/switch-endpoints`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
